import SvgIcon from 'components/Luxkit/SvgIcon'
import React from 'react'

interface Props extends React.SVGAttributes<SVGElement> {
  size?: number;
  colour?: never;
}

function QantasIcon(props: Props) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path d="M6.4 19.6h17L9.8 6.8A10 10 0 0 0 3 4H0l.2.5 1 2.3 5.1 12.7Z" fill="url(#qantas-icon-a)"/>
    <path d="M1 7.2C2.9 10 7.8 10.4 8.3 15c0 .1.2.3.4.3a17.7 17.7 0 0 1 8 3.3h.1v-.1a17.2 17.2 0 0 0-6-3.8l-.6-.2a.9.9 0 0 1-.6-.8c0-1.4 3.5-1.1 3.9-1.8v-.1c-.7-.6-1.6-1-2.5-1.2l.2.5c.2.3-.3.8-1 .2C5.5 7.3 2 9.3 0 4.9l1 2.3Z" fill="#fff"/>
    <path d="M12.2 11.7s-.7 0-1.2-.7c.1.3 0 .6-.3.6v1l1.5-.3v-.6Z" fill="url(#qantas-icon-b)"/>
    <path d="M9.2 15.4c2.5.5 5 1.5 7.3 3.2-5-4-7.2-3.2-7.3-3.2Z" fill="url(#qantas-icon-c)"/>
    <path d="M2 7.4a5.2 5.2 0 0 1-2-2.5l1 2.3C2.8 10 7.7 10.4 8.2 15 7.7 9 5 10 2 7.4Z" fill="url(#qantas-icon-d)"/>
    <defs>
      <linearGradient id="qantas-icon-a" x1="26.5" y1="15.8" x2="20.9" y2="-1.6" gradientUnits="userSpaceOnUse">
        <stop stopColor="#BE0000"/>
        <stop offset=".4" stopColor="#DE0000"/>
        <stop offset=".8" stopColor="#F60000"/>
        <stop offset="1" stopColor="red"/>
      </linearGradient>
      <linearGradient id="qantas-icon-b" x1="12.2" y1="12.8" x2="12.3" y2="11.2" gradientUnits="userSpaceOnUse">
        <stop offset=".7" stopColor="#fff" stopOpacity="0"/>
        <stop offset=".7" stopColor="#E0E0E0" stopOpacity=".3"/>
        <stop offset=".8" stopColor="#C5C5C5" stopOpacity=".5"/>
        <stop offset=".9" stopColor="#B5B5B5" stopOpacity=".8"/>
        <stop offset=".9" stopColor="#AFAFAF"/>
      </linearGradient>
      <linearGradient id="qantas-icon-c" x1="9.2" y1="18.6" x2="16.5" y2="18.6" gradientUnits="userSpaceOnUse">
        <stop stopColor="#fff" stopOpacity="0"/>
        <stop offset=".1" stopColor="#F1F1F1" stopOpacity=".1"/>
        <stop offset=".3" stopColor="#D4D4D4" stopOpacity=".3"/>
        <stop offset=".5" stopColor="silver" stopOpacity=".6"/>
        <stop offset=".7" stopColor="#B3B3B3" stopOpacity=".8"/>
        <stop offset=".9" stopColor="#AFAFAF"/>
      </linearGradient>
      <linearGradient id="qantas-icon-d" x1="0" y1="15" x2="8.2" y2="15" gradientUnits="userSpaceOnUse">
        <stop offset=".3" stopColor="#fff" stopOpacity="0"/>
        <stop offset=".5" stopColor="#EDEDED" stopOpacity=".3"/>
        <stop offset=".9" stopColor="#BDBDBD" stopOpacity=".8"/>
        <stop offset="1" stopColor="#AFAFAF"/>
      </linearGradient>
    </defs>
  </SvgIcon>
}

export default QantasIcon
